import PaginationComponent from 'components/pagination';
import { dateFormat, dateTimeFormat, onKeyPress } from 'helpers/utils';
import moment from 'moment';
import * as React from 'react';
import { useEffect } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import Text from '../../../../components/text';
import { postRicercaLotti, setPaginaSelezionataAction, setRicercaDataFine, setRicercaDataInizio, setRicercaNome, setRicercaStatoCampagna } from './_redux/actions';
import { dettaglioListLotti, formRicercaLottiSelector, isFirstPageSelector, isLastPageSelector, numeroTotalePagineSelector, paginaSelezionataSelector } from './_redux/selectors';


export const elencoStatiCampagna = [
  { valore: 1, descrizione: "Inserita" },
  { valore: 2, descrizione: "In esecuzione" },
  { valore: 3, descrizione: "In errore" },
  { valore: 4, descrizione: "Completata" },
];

const HomeCampagna: React.FC = () => {

  const toRef = React.useRef<DayPickerInput>();
  const listLotti = useAppSelector(dettaglioListLotti);
  const numeroTotalePagine = useAppSelector(numeroTotalePagineSelector);
  const isFirstPage = useAppSelector(isFirstPageSelector);
  const isLastPage = useAppSelector(isLastPageSelector);
  const paginaSelezionata = useAppSelector(paginaSelezionataSelector);
  const {
    statoCampagna,
    nome,
    dataInserimentoInizio,
    dataInserimentoFine
  } = useAppSelector(formRicercaLottiSelector);

  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    callStoricoCampagne();
  }, []);

  function handleFromChange(day: Date) {
    dispatch(setRicercaDataInizio(day))
  }

  function handleToChange(to: Date) {
    dispatch(setRicercaDataFine(to));
    if (!dataInserimentoInizio) {
      return;
    }
    if (to && moment(to).diff(moment(dataInserimentoInizio), 'months') < 2) {
      toRef.current?.getDayPicker().showMonth(dataInserimentoInizio);
    }
  }

  const callStoricoCampagne = () => {
    setPaginaSelezionata(1);
  }


  const setPaginaSelezionata = (pagina: number) => {
    dispatch(setPaginaSelezionataAction(pagina));
    dispatch(postRicercaLotti());
  }


  const getDettaglio = (id: string | number) => {
    history.push(`/admin/campagne/${id}`)
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' && nome) {
      callStoricoCampagne();
    }
    return onKeyPress(event, true);
  };

  function onNomeChange(evt: any) {
    if (evt.target.value.length <= 12) {
      dispatch(setRicercaNome(evt.target.value));
    }
  }

  function goToNuova() {
    history.push(`/admin/campagne/nuova`)
  }

  const modifiers = { start: dataInserimentoInizio, end: dataInserimentoFine };
  return (
    <div>
      <Row className="mt-4 mb-4">
        <Col md={12} className="">
          <Text title="Storico campagne" type='sottotitolo'></Text>
        </Col>
      </Row>
      <Row className="InputFromTo" style={{ alignItems: 'flex-end' }}>
        <Col>
          <Text title="Nome"></Text>
          <Form.Control type="text" onKeyPress={handleKeyPress} onChange={onNomeChange} value={nome} placeholder="nome campagna" />
        </Col>
        <Col>
          <Text title="Data inserimento dal"></Text>
          <DayPickerInput
            value={dataInserimentoInizio}
            placeholder="From"
            format="LL"
            formatDate={MomentLocaleUtils.formatDate}
            parseDate={MomentLocaleUtils.parseDate}
            inputProps={{ className: 'form-control' }}
            dayPickerProps={{
              locale: 'it',
              localeUtils: MomentLocaleUtils,
              selectedDays: [dataInserimentoInizio, { from: dataInserimentoInizio, to: dataInserimentoFine }],
              disabledDays: { after: dataInserimentoFine },
              toMonth: dataInserimentoFine,
              modifiers,
              numberOfMonths: 2,
              onDayClick: () => toRef.current?.getInput().focus(),
            }}
            onDayChange={handleFromChange}
          />
        </Col>
        <Col>
          <span className="InputFromTo-to">
            <Text title="Data inserimento al"></Text>
            <DayPickerInput
              ref={(ref: any) => toRef.current = ref}
              value={dataInserimentoFine}
              placeholder="To"
              format="LL"
              formatDate={MomentLocaleUtils.formatDate}
              parseDate={MomentLocaleUtils.parseDate}
              inputProps={{ className: 'form-control' }}
              dayPickerProps={{
                locale: 'it',
                localeUtils: MomentLocaleUtils,
                selectedDays: [dataInserimentoInizio, { from: dataInserimentoInizio, to: dataInserimentoFine }],
                disabledDays: { before: dataInserimentoInizio, after: new Date() },
                modifiers,
                month: dataInserimentoInizio,
                fromMonth: dataInserimentoInizio,
                numberOfMonths: 2,
              }}
              onDayChange={handleToChange}
            />
          </span>
        </Col>
        <Col>
          <Text title="Seleziona stato"></Text>
          <Form.Control as="select" value={statoCampagna} onChange={(e) => dispatch(setRicercaStatoCampagna(parseInt(e.target.value)))}>
            <option>Tutti</option>
            {elencoStatiCampagna.map((x, index) =>
              <option key={'statoCampagna_' + index} value={x.valore}>{x.descrizione}</option>
            )}
          </Form.Control>
        </Col>
      </Row>

      <Row className="">
        <Col className="text-center mt-3">
          <Button onClick={callStoricoCampagne}>Cerca <i className="fas fa-search iconRight ml-2"></i></Button>
          <hr />
        </Col>
      </Row>
      <Row className="">
        <Col md={12} className="text-right">
          <Button onClick={goToNuova}>Nuova campagna <i className="fas fa-plus iconRight ml-2"></i></Button>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col md="12">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Id</th>
                <th>Nome campagna</th>
                <th>Data inizio</th>
                <th>Data fine</th>
                <th>Matricola</th>
                <th>Inserimento</th>
                <th>Stato</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {listLotti.length > 0 &&
                listLotti?.map((arr, index) => (
                  <tr key={index}>
                    <td>{arr?.idLotto}</td>
                    <td>{arr?.nomeLotto}</td>
                    <td>{dateFormat(arr?.dataInizioCampagna)}</td>
                    <td>{dateFormat(arr?.dataFineCampagna)}</td>
                    <td>{arr?.matricolaOperatore || "-"}</td>
                    <td>{dateTimeFormat(arr?.dataInserimento)}</td>
                    <td>{arr?.statoNome}</td>
                    <td className="text-center">
                      <Button variant="link" className="p-0 icon-table" onClick={() => arr.idLotto ? getDettaglio(arr.idLotto) : null}><i className="fas fa-search-plus" title="Dettaglio"></i></Button>
                    </td>
                  </tr>
                ))}
              {listLotti.length === 0 && (
                <tr key={-1}>
                  <td colSpan={9} className="text-center"><Text title="Nessun risultato presente" /></td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col>
          <PaginationComponent
            numeroTotalePagine={numeroTotalePagine}
            paginaSelezionata={paginaSelezionata}
            isFirstPage={isFirstPage}
            isLastPage={isLastPage}
            setPaginaSelezionata={setPaginaSelezionata}
            elencoRisultati={listLotti}
          />
        </Col>
      </Row>

    </div >
  )
}

export default HomeCampagna;
